import React from 'react'

// Big figures and chapter numbers, set in Hubot Sans condensed. A plain span
// rather than Primer Brand's Heading: Heading only renders h1–h6, and a
// figure is not a heading. Sizes are the two the page uses.
const SIZES = {
  figure: { fontSize: 'clamp(32px, 3.6vw, 44px)', fontWeight: 600 },
  chapter: { fontSize: '32px', fontWeight: 500 },
}

const DisplayNumeral = ({ children, size = 'figure', tone = 'default', style = {} }) => (
  <span
    style={{
      display: 'block',
      // Mona Sans, the same face as every heading — Hubot Sans condensed was
      // tried and read as too narrow next to the rest of the page.
      fontFamily: 'var(--brand-heading-fontFamily)',
      letterSpacing: '-0.02em',
      lineHeight: 1,
      color: tone === 'accent' ? 'var(--cl-accent, var(--base-color-scale-blue-5))' : 'var(--brand-color-text-default)',
      ...SIZES[size],
      ...style,
    }}
  >
    {children}
  </span>
)

export default DisplayNumeral
